import { API_BASE_URL } from '../utils/constants';
import axiosInstance from './axiosInstance';

export const QueryService = {
    createQuery: async (payload) => {
        try {
            const response = await axiosInstance.post(`${API_BASE_URL}/query`, payload);
            return response.data;
        }
        catch (error) {
            throw error;
        }
    },
}